<div class="container nopad">
    <div class="filterforall" id="top-sort-list-wrapper">
        <div class="topmisty" id="top-sort-list-1">
            <div class="col-xs-12 nopad">
                <div class="divinsidefltr">
                    <div class="insidemyt col-xs-12 nopad">
                        <ul class="sortul">
                            <li class="sortli hide_lines">
                                <a (click)="sortByBest()" class="sorta name-l-2-h loader"
                                    [ngClass]="byBest && active == 'byBest' ? 'des active' :(active == 'byBest' ? 'asc active' : 'asc')">
                                    <strong>Name </strong>
                                </a>
                            </li>
                            
                            <!-- <li class="sortli hide_lines" style="width: 20%;">
                                <a (click)="sortByGuest()" class="sorta name-l-2-h loader"
                                    [ngClass]="byGuest && active == 'byGuest' ? 'des active' :(active == 'byGuest' ? 'asc active' : 'asc')">
                                    <strong>Guest Rating</strong>
                                </a>
                            </li> -->

                            <li class="sortli hide_lines">
                                <a (click)="sortByPrice()" class="sorta name-l-2-h loader"
                                    [ngClass]="byPrice && active == 'byPrice' ? 'des active' :(active == 'byPrice' ? 'asc active' : 'asc')">
                                    <strong>Price</strong>
                                </a>
                            </li>

                            <li class="sortli hide_lines">
                                <a (click)="sortByStars()" class="sorta name-l-2-h loader"
                                    [ngClass]="byStars && active == 'byStars' ? 'des active' :(active == 'byStars' ? 'asc active' : 'asc')">
                                    <strong>Star Rating</strong>
                                </a>
                            </li>

                            <!-- <li class="sortli hide_lines" style="width: 20%;">
                                <a (click)="sortByDistance()" class="sorta name-l-2-h loader"
                                    [ngClass]="byDistance && active == 'byDistance' ? 'des active' :(active == 'byDistance' ? 'asc active' : 'asc')">
                                    <strong>Distance</strong>
                                </a>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>